"use client";

import { m as motion } from "framer-motion";
import { CalendlyEmbed } from "@/components/CalendlyEmbed";

export function TidyCalMobileSection() {
  return (
    <section id="tidycal-mobile" className="section-padding pt-0 xl:hidden">
      <div className="container-wide">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <CalendlyEmbed hideIntroSection eager={false} />
        </motion.div>
      </div>
    </section>
  );
}
